import React, { Component } from 'react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }
  handleReset = () => {
    this.setState({
      hasError: false,
      error: null
    });
    window.location.href = '/';
  };
  render() {
    if (this.state.hasError) {
      // Detect language from URL without hooks
      const isEn = typeof window !== 'undefined' && window.location.pathname.startsWith('/en');
      const copy = isEn ? {
        title: 'Something Went Wrong',
        body: 'The page encountered an unexpected error. Please return to the home page.',
        button: 'Back to Home',
        devLabel: 'Error details (dev only)'
      } : {
        title: 'Terjadi Kesalahan',
        body: 'Halaman mengalami gangguan tak terduga. Silakan kembali ke beranda.',
        button: 'Kembali ke Beranda',
        devLabel: 'Detail error (dev only)'
      };
      return <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center" data-id="element-80">
          <div className="w-16 h-16 bg-forest-50 rounded-2xl flex items-center justify-center mb-6 border border-forest-100" data-id="element-81">
            <svg className="w-8 h-8 text-forest-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-82">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" data-id="element-83" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-forest-900 mb-3 font-heading" data-id="element-84">
            {copy.title}
          </h1>
          <p className="text-forest-600 text-base mb-8 max-w-sm leading-relaxed" data-id="element-85">
            {copy.body}
          </p>
          <button onClick={this.handleReset} className="h-11 px-8 bg-brand-green hover:bg-forest-600 text-white font-semibold rounded-xl text-sm transition-all shadow-sm hover:shadow-md" data-id="element-86">
            {copy.button}
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && <details className="mt-8 text-left max-w-lg w-full" data-id="element-87">
              <summary className="text-xs text-forest-400 cursor-pointer hover:text-forest-600" data-id="element-88">
                {copy.devLabel}
              </summary>
              <pre className="mt-2 text-xs text-red-600 bg-red-50 p-4 rounded-lg overflow-auto border border-red-100" data-id="element-89">
                {this.state.error.toString()}
              </pre>
            </details>}
        </div>;
    }
    return this.props.children;
  }
}